import {EMPTY_TRACKING_PARAMS} from './constants'
import {createContext} from 'react'

export default createContext({
  // Generally hydrated in App.js, but have a reasonable default
  trackingParams: EMPTY_TRACKING_PARAMS,
})
